/**
 * How a chosen thing looks, everywhere: a soft outline and a faint wash,
 * never a hard black border. Black drew the eye to the control instead of to
 * what was chosen (vendor feedback, Oct 2026).
 */
export const SELECTED = 'border-foreground/25 bg-accent/50 ring-[3px] ring-foreground/[0.06]';

/** The resting state of the same control. */
export const UNSELECTED = 'border-input';

/** For pictures (cards, tiles) where a wash would tint the image: outline only. */
export const SELECTED_FRAME = 'border-foreground/30 ring-[3px] ring-foreground/[0.07]';
